var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsBlogCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_48_40856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6328 0.160156C7.97135 0.160156 0.132812 7.9987 0.132812 17.6602C0.132812 27.3216 7.97135 35.1602 17.6328 35.1602C27.2943 35.1602 35.1328 27.3216 35.1328 17.6602C35.1328 7.9987 27.2943 0.160156 17.6328 0.160156Z",
    fill: "#01A93A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8513 18.5641C11.0857 18.5641 10.7794 18.0173 10.7794 18.0173V18.4329H9.49609V13.1318H10.7648V15.1516C11.2826 14.6485 11.8513 14.6485 11.8513 14.6485C13.5794 14.6485 13.6451 16.5881 13.6451 16.5881C13.6451 18.5058 11.8513 18.5714 11.8513 18.5714V18.5641Z",
    fill: "#01A93A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8616 14.9989V18.426H14.6366V15.2906C14.6366 14.2041 14.0605 14.2333 14.0605 14.2333V13.001C15.9199 13.001 15.8689 14.9989 15.8689 14.9989H15.8616Z",
    fill: "#01A93A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0164 16.6245C21.0164 18.5641 18.8653 18.5641 18.8653 18.5641C16.6924 18.5641 16.758 16.6245 16.758 16.6245C16.758 14.6631 18.8653 14.6631 18.8653 14.6631C21.0893 14.6631 21.0164 16.6245 21.0164 16.6245Z",
    fill: "#01A93A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.7712 18.3823C25.7712 20.3875 23.9119 20.3729 23.9119 20.3729H23.416V19.2427H23.7223C24.6264 19.2427 24.5317 18.3094 24.5317 18.3094V18.0104C24.1379 18.5208 23.416 18.4989 23.416 18.4989C21.6442 18.4989 21.666 16.6104 21.666 16.6104C21.666 14.5833 23.4671 14.6635 23.4671 14.6635C24.1671 14.6635 24.5389 15.1521 24.5389 15.1521V14.7875H25.7785V18.3823H25.7712Z",
    fill: "#01A93A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.749 8.91016H10.5156C8.7 8.91016 7.23438 10.3904 7.23438 12.206V20.0299C7.23438 21.8529 8.7 23.3258 10.5156 23.3258H15.4156L17.0854 26.0456C17.0854 26.0456 17.1 26.082 17.1365 26.1258C17.2385 26.2935 17.4135 26.4102 17.625 26.4102C17.8365 26.4102 18.0115 26.2935 18.1062 26.1331C18.15 26.082 18.1646 26.0529 18.1646 26.0529L19.8344 23.3331H24.7344C26.55 23.3331 28.0229 21.8602 28.0229 20.0372V12.2133C28.0229 10.3904 26.55 8.91745 24.7344 8.91745L24.749 8.91016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.8513 14.6412C11.8513 14.6412 11.2826 14.6412 10.7648 15.1443V13.1245H9.49609V18.4256H10.7794V18.0099C10.7794 18.0099 11.0857 18.5568 11.8513 18.5568C11.8513 18.5568 13.6451 18.4912 13.6451 16.5735C13.6451 16.5735 13.5794 14.6339 11.8513 14.6339V14.6412ZM11.5742 17.4412C11.1221 17.4412 10.7576 17.0766 10.7576 16.6245C10.7576 16.1724 11.1221 15.8078 11.5742 15.8078C12.0263 15.8078 12.3909 16.1724 12.3909 16.6245C12.3909 17.0766 12.0263 17.4412 11.5742 17.4412Z",
    fill: "#ED730A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.0522 13.001V14.2333C14.0522 14.2333 14.6283 14.2041 14.6283 15.2906V18.426H15.8533V14.9989C15.8533 14.9989 15.9043 13.001 14.0449 13.001H14.0522Z",
    fill: "#ED730A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.8653 14.6631C18.8653 14.6631 16.758 14.6631 16.758 16.6245C16.758 16.6245 16.6924 18.5641 18.8653 18.5641C18.8653 18.5641 21.0164 18.5641 21.0164 16.6245C21.0164 16.6245 21.0893 14.6631 18.8653 14.6631ZM18.8653 17.4412C18.4132 17.4412 18.0487 17.0766 18.0487 16.6245C18.0487 16.1725 18.4132 15.8079 18.8653 15.8079C19.3174 15.8079 19.682 16.1725 19.682 16.6245C19.682 17.0766 19.3174 17.4412 18.8653 17.4412Z",
    fill: "#ED730A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.5311 15.1447C24.5311 15.1447 24.1665 14.6562 23.4593 14.6562C23.4593 14.6562 21.6582 14.576 21.6582 16.6031C21.6582 16.6031 21.6363 18.4916 23.4082 18.4916C23.4082 18.4916 24.1301 18.5208 24.5238 18.0031V18.302C24.5238 18.302 24.6113 19.2354 23.7145 19.2354H23.4082V20.3656H23.904C23.904 20.3656 25.7634 20.3874 25.7634 18.3749V14.7802H24.5238V15.1447H24.5311ZM23.7728 17.4416C23.3207 17.4416 22.9561 17.077 22.9561 16.6249C22.9561 16.1729 23.3207 15.8083 23.7728 15.8083C24.2249 15.8083 24.5895 16.1729 24.5895 16.6249C24.5895 17.077 24.2249 17.4416 23.7728 17.4416Z",
    fill: "#ED730A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_40856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.132812 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsBlogCircle);
export default __webpack_public_path__ + "static/media/sns_blog_circle.ee0551eb51b95b26f6f7a0139afc98a3.svg";
export { ForwardRef as ReactComponent };